import type { MiddlewareAPI } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { configureDealershipPicker } from './config';
import type { MiddlewareManager } from '@makemydeal/dr-activities-dealership-picker';

export let cachedDealershipPickerMiddlewareMgr: MiddlewareManager | undefined;

// needed for testing
export const dealershipPickerMiddlewareClearCache = () => (cachedDealershipPickerMiddlewareMgr = undefined);

export const dealershipPickerMiddleware = (store: MiddlewareAPI) => (next: any) => (action: AnyFSA) => {
    if (action.type === bootstrapActionTypes.BOOTSTRAP_SUCCESS) {
        cachedDealershipPickerMiddlewareMgr = configureDealershipPicker();
    }
    if (cachedDealershipPickerMiddlewareMgr) {
        cachedDealershipPickerMiddlewareMgr.middleware(store)(next)(action);
    } else {
        next(action);
    }
};
